import { Hero } from "@/components/Hero";
import { StatsBar } from "@/components/StatsBar";
import { Ribbon } from "@/components/Ribbon";
import { Market } from "@/components/Market";
import { HowItWorks } from "@/components/HowItWorks";
import { Ecosystem } from "@/components/Ecosystem";
import { Michelchef } from "@/components/Michelchef";
import { Wall } from "@/components/Wall";
import { Certifications } from "@/components/Certifications";
import { AICapabilities } from "@/components/AICapabilities";
import { Menu } from "@/components/Menu";
import { Locations } from "@/components/Locations";
import { FranchiseCTA } from "@/components/FranchiseCTA";
import { Seo } from "@/components/Seo";
import { IMAGES } from "@/assets";
import { useLang } from "@/context/LanguageContext";

const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": ["Organization", "FoodEstablishment"],
  name: "RISORICE",
  legalName: "RISORICE S.r.l.",
  url: "https://risorice.it",
  logo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_risorice-ai-kitchen/artifacts/lsuoyrps_icon_cream_1024.png",
  image: IMAGES.heroDarkStore,
  description:
    "RISORICE — Il ristorante che si serve da solo. Cucina italiana 100% gluten-free, cottura MAGNETRON MICHELCHEF in 5 minuti, ritiro dal Food-Box Wall. Franchising in tutta Italia.",
  servesCuisine: "Italian",
  areaServed: "IT",
  address: { "@type": "PostalAddress", addressLocality: "Roma", addressCountry: "IT" },
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "franchising",
    email: "franchising@risorice.it",
    availableLanguage: ["Italian", "English", "Russian"],
  },
};

export default function PromoPage() {
  const { lang } = useLang();
  return (
    <>
      <Seo
        path="/promo"
        lang={lang}
        image={IMAGES.heroDarkStore}
        jsonLd={ORG_JSONLD}
        title={{
          it: "RISORICE® — Il ristorante che si serve da solo | Franchising Italia",
          en: "RISORICE® — The restaurant that serves itself | Franchise Italy",
          ru: "RISORICE® — Ресторан, который обслуживает сам себя | Франшиза Италия",
        }[lang]}
        description={{
          it: "Cucina italiana 100% gluten-free, cottura MAGNETRON MICHELCHEF® in 5 minuti, ritiro dal Food-Box Wall. Scopri il format automatizzato e apri il tuo RISORICE® in franchising.",
          en: "100% gluten-free Italian cuisine, MAGNETRON MICHELCHEF® cooking in 5 minutes, pickup from the Food-Box Wall. Discover the automated format and open your RISORICE® franchise.",
          ru: "Итальянская кухня на 100% без глютена, приготовление MAGNETRON MICHELCHEF® за 5 минут, выдача из стены Food-Box. Откройте автоматизированный формат и свою точку RISORICE® по франшизе.",
        }[lang]}
      />
      <Hero />
      <section className="bg-white py-10 md:py-14" data-testid="stats-section">
        <div className="mx-auto max-w-[1280px] px-5 md:px-8">
          <StatsBar variant="hero" />
        </div>
      </section>
      <Ribbon />
      <Market />
      <HowItWorks />
      <Ecosystem />
      <Michelchef />
      <Wall />
      <Certifications />
      <AICapabilities />
      <Menu />
      <Locations />
      <FranchiseCTA />
    </>
  );
}
